import "./App.css";
import Layout from "./pages/Layout/Layout";
import AskMeAnything from "./pages/AskMeAnything/AskMeAnything";
import Bountiful from "./pages/Bountiful/Bountiful";
import Dou from "./pages/Dou/Dou";
import GoodWithMoney from "./pages/GoodWithMoney/GoodWithMoney";
import LetsGo from "./pages/LetsGo/LetsGo";
import OurVillage from "./pages/OurVillage/OurVillage";
import Plates from "./pages/Plates/Plates";
import Smallties from "./pages/SmallTies/Smallties";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import "./assets/css/materialdesignicons.min.css";
import "./assets/scss/themes.scss";
import { Analytics } from "@vercel/analytics/react";
import CatFeeder from "./pages/CatFeeder/CatFeeder";
import GroundswellGoods from "./pages/SmallTies/Smallties";
import Partner from "./pages/Partner/Partner";

function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path="/" element={<Smallties />}></Route>
        <Route path="/dou" element={<Dou />}></Route>
        <Route path="/goodwithmoney" element={<GoodWithMoney />}></Route>
        <Route path="/feeder" element={<CatFeeder />}></Route>
        <Route path="groundswellgoods" element={<GroundswellGoods />}></Route>
        <Route path="*" element={<Layout />} /> {/* 404 Route */}
        {/* <Route path="/ad" element={<Review />} /> */}
        <Route path="/partner" element={<Partner />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
